import { create, enforce, group, test } from "vest";

import { BankStatementUpload } from "@/jenesys-types/jenesys-entities/config";

export const StatementUploadEditFormSchema = create(
  (data: BankStatementUpload) => {
    (data.extracted_details || []).forEach((line, index) => {
      group(`Line ${index + 1}`, () => {
        test(`extracted_details.${index}.Date`, "Date is required", () => {
          enforce(line.Date).isNotEmpty();
        });
        test(
          `extracted_details.${index}.Description`,
          "Description is required",
          () => {
            enforce(line.Description).isNotEmpty();
          }
        );
        test(`extracted_details.${index}.Amount`, "Amount is required", () => {
          enforce(line.Amount).isNotEmpty();
        });
        test(
          `extracted_details.${index}.Supplier`,
          "Supplier is required",
          () => {
            enforce(line.Supplier).isNotEmpty();
          }
        );
      });
    });
  }
);
